module.exports = __webpack_public_path__ + "img/004-air-conditioner.9c04b70f.svg";